import { Instagram, Megaphone, Globe, Bot } from "lucide-react";
import { Reveal } from "@/components/landing/Reveal";

const SERVICES = [
  { icon: Instagram, title: "Redes sociales con IA", text: "Publicaciones, reels y calendario de contenido que conectan con tu clienta ideal y suenan a ti.", span: "lg:col-span-7", tone: "bg-white" },
  { icon: Megaphone, title: "Anuncios que venden", text: "Campañas en Instagram, Facebook y TikTok con presupuesto pequeño y objetivos claros.", span: "lg:col-span-5", tone: "bg-[#F4A261]/15" },
  { icon: Globe, title: "Web y tienda online", text: "Una web bonita y rápida para que te encuentren en Google y puedas cobrar en línea.", span: "lg:col-span-5", tone: "bg-[#2A9D8F]/10" },
  { icon: Bot, title: "Asistente IA 24/7", text: "Respuestas automáticas en WhatsApp e Instagram para no perder ni una venta mientras duermes.", span: "lg:col-span-7", tone: "bg-white" },
];

export const Services = () => (
  <section id="servicios" className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
    <Reveal className="max-w-2xl">
      <p className="text-xs font-semibold uppercase tracking-wider text-[#E05A47]">Servicios</p>
      <h2 className="mt-3 text-3xl font-bold tracking-tight text-[#1E1A17] sm:text-4xl">Todo lo que tu negocio necesita para vender online</h2>
      <p className="mt-4 text-base text-[#6E655F] md:text-lg">Estrategia humana + velocidad de la IA. Sin jerga, sin contratos eternos.</p>
    </Reveal>
    <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-12">
      {SERVICES.map((s, i) => (
        <Reveal key={s.title} delay={i * 0.08} className={s.span}>
          <div data-testid={`service-card-${i}`} className={`group h-full rounded-2xl border border-[#E8E1D7] ${s.tone} p-8 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-md`}>
            <div className="grid h-12 w-12 place-items-center rounded-xl bg-[#1E1A17] text-white transition-colors group-hover:bg-[#E05A47]">
              <s.icon className="h-5 w-5" />
            </div>
            <h3 className="mt-6 text-xl font-semibold text-[#1E1A17] sm:text-2xl">{s.title}</h3>
            <p className="mt-3 max-w-md text-[#6E655F]">{s.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

const STEPS = [
  ["01", "Diagnóstico gratis", "Conocemos tu negocio, tu clienta y lo que ya estás haciendo."],
  ["02", "Estrategia con IA", "Creamos un plan y contenidos a tu medida en días, no meses."],
  ["03", "Activación y ventas", "Lanzamos, medimos y ajustamos para que lleguen clientas reales."],
];

export const HowItWorks = () => (
  <section className="bg-[#1E1A17] text-[#FAF7F2]">
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-wider text-[#F4A261]">Cómo funciona</p>
        <h2 className="mt-3 max-w-2xl text-3xl font-bold tracking-tight sm:text-4xl">Tres pasos y tu negocio empieza a moverse</h2>
      </Reveal>
      <div className="mt-14 grid gap-10 md:grid-cols-3">
        {STEPS.map(([n, t, d], i) => (
          <Reveal key={n} delay={i * 0.1}>
            <div className="border-t border-[#FAF7F2]/15 pt-6">
              <span className="font-display text-5xl font-bold text-[#E05A47]">{n}</span>
              <h3 className="mt-4 text-xl font-semibold">{t}</h3>
              <p className="mt-2 text-[#FAF7F2]/70">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
